/**
 * SCRIPT DE DEBUG PARA AUTENTICACIÓN
 * 
 * Ejecuta esto en la consola del navegador (DevTools > Console) en la página de login
 * para diagnosticar problemas de autenticación y tokens
 */

window.debugAuth = {
  // Obtener información de tokens almacenados
  verTokens() {
    console.log('=== TOKENS ALMACENADOS ===');
    console.log('store_tid:', localStorage.getItem('store_tid'));
    console.log('access_token:', localStorage.getItem('access_token'));
    console.log('token:', localStorage.getItem('token'));
    console.log('usuario:', JSON.parse(localStorage.getItem('usuario') || 'null'));
  },

  // Verificar headers que se están enviando
  async verHeaders() {
    console.log('=== HEADERS CONFIGURADOS EN AXIOS ===');
    const token = localStorage.getItem('store_tid');
    console.log('Token en localStorage:', token ? '✓ Existe' : '✗ No existe');
    if (token) {
      console.log('Bearer token que se enviará:', `Bearer ${token.substring(0, 20)}...`);
    }
  },

  // Simular petición a /api/v1/tiendas/
  async testTiendasEndpoint() {
    console.log('=== PRUEBA DE ENDPOINT /api/v1/tiendas/ ===');
    try {
      const token = localStorage.getItem('store_tid');
      const response = await fetch('/api/v1/tiendas/', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          ...(token && { 'Authorization': `Bearer ${token}` })
        }
      });
      
      console.log('Status:', response.status);
      console.log('Status Text:', response.statusText);
      
      if (response.status === 401) {
        console.error('❌ ERROR 401: Token no es válido o no se está enviando');
        console.log('Headers enviados:', {
          'Authorization': token ? `Bearer ${token.substring(0, 20)}...` : 'NO ENVIADO'
        });
      } else if (response.ok) {
        const data = await response.json();
        console.log('✓ Respuesta exitosa:', data);
      } else {
        console.log('Respuesta:', response);
      }
    } catch (error) {
      console.error('Error en petición:', error);
    }
  },

  // Verificar que el localStorage se estén actualizando después del login
  monitorLogin() {
    console.log('=== MONITOREANDO CAMBIOS EN localStorage ===');
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function(key, value) {
      if (key === 'store_tid' || key === 'access_token' || key === 'usuario') {
        console.log(`✓ [localStorage] ${key} actualizado:`, 
          key === 'store_tid' ? `${value.substring(0, 30)}...` : value);
      }
      return originalSetItem.apply(localStorage, arguments);
    };
  },

  // Mostrar todos los comandos disponibles
  help() {
    console.log(`
=== COMANDOS DISPONIBLES ===
window.debugAuth.verTokens()           - Ver tokens almacenados
window.debugAuth.verHeaders()          - Ver headers configurados
window.debugAuth.testTiendasEndpoint() - Probar endpoint /api/v1/tiendas/
window.debugAuth.monitorLogin()        - Monitorear cambios en localStorage
window.debugAuth.help()                - Mostrar esta ayuda
    `);
  }
};

// Mostrar instrucciones
console.log('%c🔐 DEBUG DE AUTENTICACIÓN ACTIVADO', 'color: green; font-weight: bold;');
console.log('Ejecuta: window.debugAuth.help() para ver comandos disponibles');
